import React from 'react';
import { FormHelperText } from '@material-ui/core';

export const renderError = ({ input, label, meta: { touched, error }, children, ...custom }) => (
    <FormHelperText error={error && touched}>{touched && error}</FormHelperText>
)